import Image from 'next/image';
import { CarIncludeType } from './car-includes.type';
import { AVAILABLE_LANGUAGES } from '@/constants';
import Typography from '@/components/shared/typography/typography.component';

export const CarIncludeItem = ({
    item,
    lang,
    itemTextVariant = 'text-body2 md:text-body2Medium',
}: {
    item: CarIncludeType;
    lang: AVAILABLE_LANGUAGES;
    itemTextVariant?: string;
}) => {
    return (
        <div className="flex gap-x-2 items-center justify-start">
            <Image
                src={item.icon.src}
                alt={item.title.en}
                width={28}
                height={28}
            />
            <div>
                <Typography className={`text-gray-700 ${itemTextVariant}`}>
                    {item.title[lang]}
                </Typography>
            </div>
        </div>
    );
};
